import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-coupon",
  "use": "icon-coupon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-coupon\">\n  <path d=\"M896 192H128c-35.3 0-64 28.7-64 64v128c35.3 0 64 28.7 64 64s-28.7 64-64 64v192c35.3 0 64 28.7 64 64s-28.7 64-64 64v128c0 35.3 28.7 64 64 64h768c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64z m0 704H128v-96c53-14.3 91.9-61.7 91.9-118.7S181 464.9 128 450.6V256h768v194.6c-53 14.3-91.9 61.7-91.9 118.7s38.9 104.4 91.9 118.7v96z\" p-id=\"4502\" />\n  <path d=\"M320 384h384v64H320zM320 512h256v64H320z\" p-id=\"4503\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol